export const gtmID = process.env.NEXT_PUBLIC_GTM_ID ?? null;

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer?: Record<string, any>[];
  }
}
